import { useState } from "react";
import { Facebook, Twitter, Link2, Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

interface ArticleShareButtonsProps {
  title: string;
  slug: string;
}

export function ArticleShareButtons({ title, slug }: ArticleShareButtonsProps) {
  const [copied, setCopied] = useState(false);
  const url = `https://mysabbat.dk/artikel/${slug}`;
  const encodedUrl = encodeURIComponent(url);
  const encodedTitle = encodeURIComponent(title);

  const shareLinks = {
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
    twitter: `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`,
  };

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      toast.success("Link kopieret til udklipsholder!");
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error("Kunne ikke kopiere link");
    }
  };

  return (
    <div className="flex items-center gap-4 py-6">
      <span className="text-sm font-medium text-muted-foreground">Del artikel:</span>
      <div className="flex items-center gap-2">
        <Button
          variant="outline"
          size="icon"
          className="w-10 h-10 rounded-full hover:bg-[#1877F2] hover:text-white hover:border-[#1877F2] transition-all"
          onClick={() => window.open(shareLinks.facebook, "_blank", "width=600,height=400")}
          aria-label="Del på Facebook"
        >
          <Facebook className="w-5 h-5" />
        </Button>
        <Button
          variant="outline"
          size="icon"
          className="w-10 h-10 rounded-full hover:bg-[#1DA1F2] hover:text-white hover:border-[#1DA1F2] transition-all"
          onClick={() => window.open(shareLinks.twitter, "_blank", "width=600,height=400")}
          aria-label="Del på Twitter/X"
        >
          <Twitter className="w-5 h-5" />
        </Button>
        <Button
          variant="outline"
          size="icon"
          className={`w-10 h-10 rounded-full transition-all ${
            copied ? "bg-lp-green text-white border-lp-green" : "hover:bg-muted"
          }`}
          onClick={copyLink}
          aria-label="Kopiér link"
        >
          {copied ? <Check className="w-5 h-5" /> : <Link2 className="w-5 h-5" />}
        </Button>
      </div>
    </div>
  );
}

export default ArticleShareButtons;
